import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../../../../shared/API/apiClient";
import { Recycle } from "lucide-react";

export default function WaterRecycledDetails() {
  const navigate = useNavigate();

  const location = useLocation();
 

  const saved = JSON.parse(sessionStorage.getItem("water_filters"));

  const reporting_year_id =
    location.state?.reporting_year_id || saved?.reporting_year_id;

  const legal_entity_id =
    location.state?.legal_entity_id || saved?.legal_entity_id;

    

  const activity_type_id = 14; // hard coded id

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [total, setTotal] = useState(0);

  // API call
  useEffect(() => {
    if (!reporting_year_id || !legal_entity_id) return;

    const fetchBreakdown = async () => {
      try {
        const res = await apiClient.get("/api/water-summary/breakdown", {
          params: {
            reporting_year_id,
            legal_entity_id,
            activity_type_id,
          },
        });

        if (res.data.code === 200) {
          const resData = res.data;

          setData(resData.breakdown || []);
          setSummary(resData.summary || {});
          setTotal(resData.total || 0);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchBreakdown();
  }, [reporting_year_id, legal_entity_id]);

  return (
    <div className="dash-page">
      <div className="ws-title">Breakdown by Reuse Type</div>
      <div className="ws-subtitle">
        Operational efficiency view of water reused on-site
      </div>

      {/* Top Metric */}
      <div className="ws-top-metric">
        <Recycle size={22} />
        <span className="ws-top-value">{total}</span>
        <span className="ws-top-unit">m³ total recycled</span>
      </div>

      {/* Summary Cards */}
      <div className="ws-stats-grid">
        <div className="ws-stat-card">
          <div className="ws-stat-label">Reuse Categories</div>
          <div className="ws-stat-value">{summary?.categories?.value || 0}</div>
        </div>

        <div className="ws-stat-card">
          <div className="ws-stat-label">Largest Reuse Stream</div>
          <div className="ws-stat-value">{summary?.largest?.label || "-"}</div>
        </div>

        <div className="ws-stat-card">
          <div className="ws-stat-label">Avg per Category</div>
          <div className="ws-stat-value">{summary?.average?.value || 0} m³</div>
        </div>
      </div>

      {/* Table */}
      <div className="ws-card">
        <div className="ws-card-title">Reuse Type Breakdown</div>

        <table className="ws-table">
          <thead>
            <tr>
              <th>Reuse Type</th>
              <th>Quantity (m³)</th>
              <th>% Contribution</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, i) => (
              <tr key={i}>
                <td>{item.label}</td>
                <td>{item.value}</td>
                <td>{item.percentage}%</td>
              </tr>
            ))}

            <tr className="ws-total-row">
              <td>Total Recycled</td>
              <td>{total}</td>
              <td>100%</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Progress */}
      <div className="ws-card">
        <div className="ws-card-title">Contribution by Reuse Type</div>

        {data.map((item, i) => (
          <div key={i} className="ws-progress-row">
            <div className="ws-progress-header">
              <span>{item.label}</span>
              <span>
                {item.value} m³ · {item.percentage}%
              </span>
            </div>

            <div className="ws-progress-bar">
              <div
                className="ws-progress-fill"
                style={{ width: `${item.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Back */}
      <div className="ws-back" onClick={() => navigate(-1)}>
        ← Back to Water Summary
      </div>

      <div className="ws-footer">
        Reuse categories reflect operational efficiency.
      </div>
    </div>
  );
}
